import Vue from 'vue'
import App from './App.vue'
import router from './router'

import "./assets/silution.scss"
import "./assets/animate.css"
import animate from "./assets/animate"

Vue.config.productionTip = false;

Vue.prototype.$animate = animate;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
